// This file is a modified version of @hotwired/stimulus-loading that handles
// the fact we have Stimulus controllers spread out over multiple folders.

import { Application } from "@hotwired/stimulus"

const application = Application.start()
const controllers = import.meta.glob('~/**/*_controller.js', { eager: true })

// nameToModuleMap.forEach(([name, module]) => {
//   application.register(name, module.default)
// })

// Configure Stimulus development experience
application.debug = false
window.Stimulus = application

const controllerAttribute = "data-controller"
const registeredControllers = {}
const controllersFolder = {}
const controllersDefinition = {}

Object.keys(controllers).forEach(function (key) {
  if (key.includes("_controller")) {
    let [empty, folder, ...rest] = key.split('/')
    let name = rest.join('/').replace(/\//g, "--").replace("_controller", "").replace(".js", "")
    controllersFolder[name] = folder
    controllersDefinition[name] = controllers[key]
  }
})

let whenAppAvailable = function (callback) {
  const interval = 30; // ms
  window.setTimeout((function () {
    if (window.App) {
      callback()
    } else {
      window.setTimeout(whenAppAvailable(callback), interval)
    }
  }), interval)
}

whenAppAvailable(function () {
  Object.entries(controllersDefinition).forEach(([name, module]) => {
    application.register(name, module.default)
  })
})

